import { render } from "./ReservationRevoke.vue?vue&type=template&id=61be2cb3"
import script from "./ReservationRevoke.vue?vue&type=script&lang=js"
export * from "./ReservationRevoke.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Askar\\personalArea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__